import takeRequest from '~/store/takeRequest';
import { registerOfferPerson } from './actions';

export function* offersSaga() {
  yield takeRequest(registerOfferPerson);
}
